/**
 * Інбокс і стрічка (A3, C1).
 *
 * Інбокс існує заради однієї властивості: **записати, не вирішуючи куди**.
 * Момент, коли думка приходить, і момент, коли зрозуміло, куди вона
 * належить, — різні. Застосунок, який вимагає обрати категорію до введення
 * тексту, губить саме ті думки, заради яких його відкривали.
 *
 * Тому розбір інбокса — окрема дія, і вона теж має бути дешевою: рядок
 * або стає справою в плані, або зникає. Третій варіант («лишити думати
 * далі») уже є за замовчуванням — рядок просто лишається.
 */
import { DomainError } from "../domain/entities.js";
import { deleteEntry } from "./entries.js";
import { addIntent } from "./plan.js";
/** Скільки рядків інбокса читати за раз. */
export const INBOX_LIMIT = 200;
/** Скільки записів стрічки читати за раз. */
export const FEED_PAGE = 30;
export async function listInbox(ctx, limit = INBOX_LIMIT) {
    return ctx.entries.byKind("inbox", limit);
}
/** Сторінка стрічки. `before` — дата останнього показаного запису. */
export async function listFeed(ctx, before = null, limit = FEED_PAGE) {
    return ctx.entries.feed(before, limit);
}
/**
 * Рядок інбокса стає справою в плані горизонту.
 *
 * Запис не копіюється, а позначається розібраним: інакше та сама думка
 * лишилася б у двох місцях, і інбокс перестав би означати «те, що чекає
 * на рішення».
 */
export async function fileToPlan(ctx, id, horizonKey) {
    const entry = await ctx.entries.byId(id);
    if (!entry || entry.deletedAt)
        throw new DomainError(`запису ${id} немає`);
    if (entry.kind !== "inbox")
        throw new DomainError("розбирати можна лише інбокс");
    const text = entry.title?.trim();
    if (!text)
        throw new DomainError("порожній рядок інбокса нікуди не подіти");
    const item = await addIntent(ctx, horizonKey, text);
    // Через `deleteEntry`, а не `save` руками: інакше рядок лишився б у пошуку.
    await deleteEntry(ctx, id);
    return { item };
}
/**
 * Прибрати рядок з інбокса.
 *
 * Видалення мʼяке — синхронізації потрібен tombstone, інакше рядок
 * «воскресне» з іншого пристрою.
 */
export async function discardFromInbox(ctx, id) {
    const entry = await ctx.entries.byId(id);
    if (!entry || entry.deletedAt)
        throw new DomainError(`запису ${id} немає`);
    if (entry.kind !== "inbox")
        throw new DomainError("прибирати можна лише з інбокса");
    await deleteEntry(ctx, id);
}
//# sourceMappingURL=inbox.js.map